import { render } from "./ProspectsActionModal.vue?vue&type=template&id=6df10597&scoped=true"
import script from "./ProspectsActionModal.vue?vue&type=script&lang=js"
export * from "./ProspectsActionModal.vue?vue&type=script&lang=js"

import "./ProspectsActionModal.vue?vue&type=style&index=0&id=6df10597&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6df10597"]])

export default __exports__